module.exports = __webpack_public_path__ + "static/media/ccapi_105.f55d15f3.ico";